var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa-0"},[_c('b',[_vm._v(_vm._s(_vm.label))]),(_vm.description)?_c('p',[_vm._v(_vm._s(_vm.description))]):_vm._e(),_c('div',{staticClass:"editorfield-holder",attrs:{"id":this.hash(this.label+'_'+this.id)}})])}
var staticRenderFns = []

export { render, staticRenderFns }